import React from 'react';

import { CSSBlockPage } from '@core/constants';
import { useAppSelector } from '@core/hooks/appHooks';
import { selectUser } from '@core/store/userSlice/userSlice';

import AircraftData from '../../mockData/dashboard';
import DashboardContentManufacturer from './_manufacturer';

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  const CSSBlock = 'home';
  const user = useAppSelector(selectUser);

  return (
    <div className={`${CSSBlockPage} ${CSSBlock}`}>
      {/* <p className={`${CSSBlockPage}__title`}>Welcome {user?.firstName}!</p> */}

      <div className={`${CSSBlock}__content`}>
        <DashboardContentManufacturer aircrafts={AircraftData.aircrafts} />
      </div>
    </div>
  );
};

export default Home;
